<template>
    <div class="text-16/150 font-semibold text-ash">
        <p>
            {{ title }}
        </p>
        <NuxtLink
            :to="'tel:' + phoneLink"
            class="text-accent transition-colors duration-300 hover:text-accent-700">
            <slot />
        </NuxtLink>
        <p class="mt-0.5 text-12/116 font-medium">
            {{ description }}
        </p>
    </div>
</template>

<script setup lang="ts">
defineProps({
    title: {
        type: String as PropType<string>,
        required: true,
    },
    phoneLink: {
        type: String as PropType<string>,
        required: true,
    },
    description: {
        type: String as PropType<string>,
        required: true,
    },
})
</script>
